import React, { Component } from 'react'

import Modal from '../Modal/Modal'
import Form from '../Form/Form'

class EditPhoneNumber extends Component {

    state = {
        phoneNumber: this.props.phoneNumber,
    }

    onSave = () => {
        this.props.onSave(this.state)
    }

    render() {
        const { phoneNumber = '' } = this.state

        return (
          <Modal
            narrow
            extraClassName="EditPhoneNumber"
            onCancel={this.props.onClose}
            onSave={this.onSave}
            saveText="Save"
            mode="edit"
            title="Phone number">
            <Form>
                <div>
                    <input
                        type="tel"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        placeholder="Phone number"
                        value={phoneNumber}
                        onChange={e => this.setState({ phoneNumber: e.target.value })} />
                </div>
            </Form>
          </Modal>
        )
    }
}

export default EditPhoneNumber



// WEBPACK FOOTER //
// ./src/components/LBUs/EditPhoneNumber.js